import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'stockholm-bank-svg-icon',
    templateUrl: 'stockholm-bank-svg-icon.component.html',
    standalone: false
})

export class StockholmBankSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
